<template>
  <b-form-group
    label="Buton Etkileti"
    label-for="cta_button"
  >
    <b-form-input
      id="cta_button"
      v-model="dataItem.cta_button"
      placeholder="Buton Etkileti"
    />
  </b-form-group>
</template>

<script>
import {
  BFormGroup, BFormInput,
} from 'bootstrap-vue'

export default {
  name: 'CtaButton',
  components: {
    BFormGroup,
    BFormInput,
  },
  computed: {
    dataItem() {
      return this.$store.getters['brands/dataItem']
    },
  },
}
</script>
